import { ActionTypes } from '../constants/index';

export function getLeads(): Object {
  return {
    type: ActionTypes.LEAD_GET_REQUEST,
    payload: {},
  };
}

export function refreshLeads(): Object {
  return {
    type: ActionTypes.LEAD_REFRESH_REQUEST,
    payload: {},
  };
}


export function deleteLeads(leadUrlsafes: Object): Object {
  return {
    type: ActionTypes.LEAD_DELETE_REQUEST,
    payload: { leadUrlsafes },
  };
}



// WEBPACK FOOTER //
// ./scripts/actions/lead.js